export default __webpack_public_path__ + "static/media/budget-lang-selected.2f6d2bc8.png";